// extracted by mini-css-extract-plugin
module.exports = {"headings":"rich-text_headings__Mn_DI"};